var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 593,
    viewBox: "0 0 360 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.056 262.305L-127.622 358.412C-127.622 358.412 -147.725 359.902 -148.989 338.296C-151.929 288.074 -106.955 173.344 3.73628 147.947C114.427 122.549 196.684 190.548 217.062 231.387C227.285 251.875 210.056 262.305 210.056 262.305Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.973 466.607L230.416 522.068C226.995 531.769 215.589 534.918 208.235 528.122C178.409 500.559 112.957 439.562 90.2577 414.287C86.6617 408.483 90.7128 401.299 92.7098 399.387C94.6065 397.572 97.1717 393.671 103.218 394.545C123.726 400.818 208.897 434.406 241.821 447.461C249.071 450.336 252.691 458.902 249.973 466.607Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-141.253 438.389L-144.573 544.542C-145.08 560.752 -133.303 574.417 -118.074 575.29L180.201 592.381C200.92 593.569 207.033 562.852 187.638 555.012L-111.975 418.586C-125.568 412.396 -140.762 422.673 -141.253 438.389Z",
    fill: "#F1F1F1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M383.09 25.6222L376.116 214.622C376.116 214.622 373.533 225.169 362.254 222.221C336.034 215.366 284.741 173.226 290.156 112.289C295.57 51.3508 344.101 20.5279 368.416 16.8862C380.614 15.0593 383.09 25.6222 383.09 25.6222Z",
    fill: "#F1F1F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/main_bg.b7fcb5a3a6cd23ca6dab60001675e231.svg";
export { ForwardRef as ReactComponent };